import React, { Component, useState } from 'react';
// Material-UI
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Button,
    Dialog,
    Grid,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Stepper,
    Step,
    StepLabel,
    Input,
    FormHelperText
} from '@material-ui/core/';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import 'date-fns';
// Components
import AppBarModal from '../../general/AppBarModal';
import {
    formulario,
    obtenerValores,
    mostrarError,
    crear_form_data,
    consulta,
    obtenerValoresFiltros,
    obtenerPermisosValorAlt
} from '../../../global/js/funciones';
import { PasosCrearSolicitud } from './MatriculasMenu';
import {
    DEPARTAMENTOS_ACADEMICOS,
    PROGRAMAS,
    MOTIVOS_SOLICITUD_NOTAS,
    PORCENTAJES_CORRE_NOTAS,
    CORTES_CORRE_NOTAS

} from './helper';
import AlertasSimple from '../../general/AlertasSimple';
import TareasTerminadas from '../../general/TareasTerminadas';
import emma_w from '../../../global/imagenes/emma_w.png';
import BuscarSelect from '../../general/BuscarSelect';
import InputFile from "../../general/InputFile";


const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2)
    }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1)
    }
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        width: '100%',
        marginTop: 15,
        '& > *': {
            margin: theme.spacing(0.5)
        }
    },
    alert: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    },
    list: {
        marginTop: 20,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300
    },
    backButton: {
        marginRight: theme.spacing(1)
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    inline: {
        display: 'inline'
    },
    textarea: {
        width: '100%',
        padding: theme.spacing(2),
        border: '1px solid #ccc',
        borderRadius: theme.spacing(1),
        fontSize: '1rem',
        marginBottom: theme.spacing(2), // Espacio inferior para separar el botón
        // minHeight: '50px',
        // maxHeight: '50px',
        resize: 'none'  // Esto deshabilitará el cambio de tamaño
    },
}));

export default class ModalCorreccionNotas extends Component {

    constructor(props) {
        super(props);
        this.formEndRef = React.createRef();
        this.state = {
            steps: ['Datos Correción'],
            activeStep: 0,
            cargando: false,
            programaSelected: '',
            materiaSelected: '',
            porcentajeSelected: '',
            corteSelected: '',
            listarPrograma: [],
            listarEstudiante: [],
            materiasProfesor: [],
            estudiantesProfesor: [],
            porcentajesNotas: [],
            cortesNotas: [],
            nombre_materia: '',
            nombre_estudiante: '',
            MotivoNotas: '',
            comentario: '',
            cargando_text: '',
            adjunto_motivo: '',
            fileInput: React.createRef(null),
        };
    }


    async componentDidUpdate({ open }, { programaSelected, materiaSelected }) {
        const { open: openNew, tipo } = this.props
        const { programaSelected: programaSelectedNew, materiaSelected: materiaSelectedNew } = this.state
        if (open !== openNew) {
            if (openNew) {
                this.reiniciarEstado();
                this.setState({ cargando: true, cargando_text: 'Cargando ..' })
                let programas = await this.ObtenerProgramasProfesor()
                let listarPrograma = []
                let MotivosNotas = []
                if(!(programas.error)) listarPrograma = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': PROGRAMAS }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'codigos_in', 'valor': programas.programas }]);
                if (tipo.codigo == 'Mat_Pro_Cor_Nota') {
                    MotivosNotas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': MOTIVOS_SOLICITUD_NOTAS }, { 'llave': 'estado', 'valor': 1 }, {'llave': 'valora', 'valor': 'normal'}]);
                } else if (tipo.codigo == 'Mat_Pro_Cor_Nota_E') {
                    MotivosNotas = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': MOTIVOS_SOLICITUD_NOTAS }, { 'llave': 'estado', 'valor': 1 }, {'llave': 'valora', 'valor': 'extem'}]);
                }
                listarPrograma = listarPrograma.map(( Val ) => ({
                    value: Val.id,
                    label: Val.nombre,
                    codigo: Val.codigo,
                }));

                let porcentajesNotas = []
                let cortesNotas = []

                if (tipo.codigo == 'Mat_Pro_Cor_Nota_E') {
                    porcentajesNotas = await obtenerValores(PORCENTAJES_CORRE_NOTAS)
                    porcentajesNotas = porcentajesNotas.map((Val) => ({
                        value: Val.id,
                        label: Val.nombre,
                        codigo: Val.codigo,
                    }));
                    cortesNotas = await obtenerValores(CORTES_CORRE_NOTAS)
                    cortesNotas = cortesNotas.map((Val) => ({
                        value: Val.id,
                        label: Val.nombre,
                        codigo: Val.codigo,
                    }));
                }
                this.setState({
                    listarPrograma,
                    MotivosNotas,
                    porcentajesNotas,
                    cortesNotas,
                    cargando: false
                })
            }
        }

        if (programaSelectedNew.value && programaSelectedNew.value !== programaSelected.value) {
            this.setState({ cargando: true })
            let DatosProfesor = await this.ObtenerDatosProfesor(programaSelectedNew.codigo)

            let materiasProfesor = DatosProfesor.materias.map((e) => ({
                value: `${e.nombre_grupo} - ${e.nombre_materia}`,
                label: `${e.nombre_grupo} - ${e.nombre_materia}`,
                cod_materia: e.cod_materia,
                cod_pensum: e.cod_pensum,
                cod_unidad: e.cod_unidad,
                id_grupo: e.id_grupo,
                nombre_materia: e.nombre_materia,
                nombre_grupo: e.nombre_grupo,
            }));

            this.setState({ cargando: false, materiasProfesor })
        }

        if (materiaSelectedNew.value && materiaSelectedNew.value !== materiaSelected.value) {
            this.setState({ cargando: true })
            let DatosProfesor2 = await this.ObtenerEstudiantesProfesor(materiaSelectedNew.id_grupo)

            let estudiantesProfesor = DatosProfesor2.estudiantes.map((e) => ({
                value: `${e.num_identificacion_estudiante} - ${e.nom_largo}`,
                label: `${e.num_identificacion_estudiante} - ${e.nom_largo}`,
                id_grupo: e.id_grupo,
                nom_largo: e.nom_largo,
                num_identificacion_estudiante: e.num_identificacion_estudiante,
            }));

            this.setState({ cargando: false, estudiantesProfesor })
        }
    }

    reiniciarEstado() {
        this.setState({
            cargando: true,
            cargando_text: "Cargando..",
            programaSelected: '',
            materiaSelected: '',
            porcentajeSelected: '',
            corteSelected: '',
            porcentajeNotas: '',
            cortesNotas: '',
            nombre_materia: '',
            nombre_estudiante: '',
            MotivoNotas: '',
            nota: '',
            comentario: '',
            adjunto_motivo: '',
            MotivosNotas: '',
            otro_motivo: '',
        });
    }


    handleNext = () => {
        const { steps, activeStep } = this.state
        const { crear_solicitud, validar_datos } = this

        if (activeStep == 0 && validar_datos()) return;

        if (activeStep == steps.length - 1) {
            crear_solicitud();
        } else {
            this.setState({ activeStep: activeStep + 1 })
        }
    };


    // handleBack = () => {
    //     const { activeStep } = this.state
    //     this.setState({ activeStep: activeStep - 1 });
    // };

    validar_estado_no_null = (nombre_estados) => {
        for (let index = 0; index < nombre_estados.length; index++) {
            const element = nombre_estados[index];
            if (
                this.state[element] == '' ||
                this.state[element] == undefined ||
                this.state[element] == null
            ) return true;
        }
        return false
    }

    ObtenerProgramasProfesor = () => {
        return new Promise((resolve) => {
            consulta(`api/v1.0/matriculas/ObtenerProgramasProfesor`, null, null, (error, estado, resp) => {
                resolve(resp);
            });
        });
    }

    ObtenerDatosProfesor = (programa) => {
        return new Promise((resolve) => {
            consulta(`api/v1.0/matriculas/ObtenerDatosProfesor/${programa}`, null, null, (error, estado, resp) => {
                resolve(resp);
            });
        });
    }

    ObtenerEstudiantesProfesor = (grupo) => {
        return new Promise((resolve) => {
            consulta(`api/v1.0/matriculas/ObtenerEstudiantesProfesor/${grupo}`, null, null, (error, estado, resp) => {
                resolve(resp);
            });
        });
    }

    cambiarEstado = (estados) => {
        this.setState(estados)
    }


    onChangeStateForInput = async (event) => {
        const { target: { value, name } } = event
        this.setState({
            [name]: value
        })
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({ adjunto_motivo: file });
        } else {
            console.error("No se seleccionó ningún archivo.");
        }
    };

    Datos_Correcion = () => {
        const {
            nombre_estudiante,
            nota,
            comentario,
            listarPrograma,
            MotivosNotas,
            programaSelected,
            materiaSelected,
            porcentajeSelected,
            corteSelected,
            materiasProfesor,
            estudiantesProfesor,
            porcentajesNotas,
            cortesNotas,
            adjunto_motivo,
            fileInput,
            otro_motivo,
            MotivoNotas

        } = this.state

        const { tipo } = this.props
        const [error, setError] = useState(null);
        const {onChangeStateForInput, handleFileChange} = this;
        const [caracteresRestantes, setCaracteresRestantes] = useState(400); // Estado para el contador

        const [motivoSeleccionado, setMotivoSeleccionado] = useState(MotivosNotas.find(m => m.id === MotivoNotas) || null);

        const handleMotivoChange = (event) => {
            const valorSeleccionado = MotivosNotas.find(m => m.id === event.target.value) || null;
            setMotivoSeleccionado(valorSeleccionado);
            onChangeStateForInput({ target: { name: 'MotivoNotas', value: event.target.value } }); // Actualiza el estado padre con el ID}
        };

        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <BuscarSelect datos={listarPrograma} cambiarEstado={(value) => this.setState({ programaSelected: value })} valor={programaSelected} id='select-programa' nombre='Programa' placeholder='Seleccione Programa' />
                </Grid>
                <Grid item xs={12}>
                    <BuscarSelect datos={programaSelected.value ? materiasProfesor : [{ 'label': <em>Para mostrar debe seleccionar el programa</em> }]} cambiarEstado={(value) => this.setState({ materiaSelected: value })} valor={materiaSelected} id='select-materia' nombre='Materia' placeholder='Seleccione Materia' />
                </Grid>
                {tipo.codigo == 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={12}>
                        <BuscarSelect datos={materiaSelected.value ? estudiantesProfesor : [{ 'label': <em>Para mostrar debe seleccionar la materia</em> }]} cambiarEstado={(value) => this.setState({ nombre_estudiante: value })} valor={nombre_estudiante} id='select-estudiante' nombre='Estudiante' placeholder='Seleccione Estudiante' />
                    </Grid>
                }
                {tipo.codigo == 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={4}>
                        <BuscarSelect datos={porcentajesNotas} cambiarEstado={(value) => this.setState({ porcentajeSelected: value })} valor={porcentajeSelected} id='select-porcentaje' nombre='Porcentaje' placeholder='Seleccione Porcentaje' />
                    </Grid>
                }
                {tipo.codigo == 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={4}>
                        <BuscarSelect datos={cortesNotas} cambiarEstado={(value) => this.setState({ corteSelected: value })} valor={corteSelected} id='select-corte' nombre='Corte' placeholder='Seleccione Corte' />
                    </Grid>
                }
                {tipo.codigo == 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={4} >
                        <FormControl className='form-control'>
                            <InputLabel>Nota *</InputLabel>
                            <Input
                                name='nota'
                                defaultValue={nota}
                                required={true}
                                onChange={(event) => {
                                    const value = event.target.value;
                                    onChangeStateForInput(event);
                                    setError(value === '' || /^([0-4](\.\d+)?|5(\.0+)?)$/.test(value) ? null : "Por favor, ingresa una nota válida entre 0 y 5.");
                                }}
                            />
                            {error && (
                                <FormHelperText error>{error}</FormHelperText>
                            )}
                            <FormHelperText>Ejemplo de formato correcto: 4.5, 3.2</FormHelperText>
                        </FormControl>
                    </Grid>
                }
                {/* <Grid item xs={6}>
                    <FormControl className='form-control'>
                        <InputLabel>Motivo de la solicitud de apertura o correccion de notas</InputLabel>
                        <Select
                            name='MotivoNotas'
                            value={MotivoNotas}
                            onChange={onChangeStateForInput}
                            required={true}
                        >
                            {
                                MotivosNotas.map((ti) => (
                                    <MenuItem key={ti.id} value={ti.id}> {ti.nombre} </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid> */}
                <Grid item xs={6}>
                    <FormControl className='form-control'>
                        <InputLabel>Motivo de la solicitud de apertura o correccion de notas *</InputLabel>
                        <Select
                            name='MotivoNotas'
                            value={motivoSeleccionado ? motivoSeleccionado.id : ''}
                            required={true}
                            onChange={handleMotivoChange}
                        >
                            {MotivosNotas.map((ti) => (
                            <MenuItem key={ti.id} value={ti.id} codigo={ti.codigo}>
                                {ti.nombre}
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {/* {tipo.codigo === 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={6} >
                        <FormControl className='form-control'>
                            <InputLabel>Otro Motivo</InputLabel>
                            <Input
                                name='otro_motivo'
                                defaultValue={otro_motivo}
                                required={false}
                            />
                        </FormControl>
                    </Grid>
                } */}
                {motivoSeleccionado && motivoSeleccionado.codigo === 'Otro_Motivo_C' && (
                    <Grid item xs={6}>
                        <FormControl className='form-control'>
                            <InputLabel>Otro Motivo *</InputLabel>
                            <Input
                            name='otro_motivo'
                            defaultValue={otro_motivo}
                            onChange={onChangeStateForInput}
                            required={false}
                            />
                        </FormControl>
                    </Grid>
                )}
                {tipo.codigo == 'Mat_Pro_Cor_Nota_E' &&
                    <Grid item xs={(tipo.codigo == 'Mat_Pro_Cor_Nota_E' && !(motivoSeleccionado && motivoSeleccionado.codigo == 'Otro_Motivo_C')) ? 6 : 12}>
                        <TextField
                            className='oculto'
                            ref={fileInput}
                            type="file"
                            id="adjunto_motivo"
                            name="adjunto_motivo"
                            label={'Adjunto de Motivo *'}
                            fullWidth
                            autoComplete="billing address-line1"
                            onChange={handleFileChange}
                        />
                        <InputFile label = 'Adjunto de Motivo *' id = 'adjunto_motivo' required = { false } value = { adjunto_motivo.name }/>
                    </Grid>
                }
                <Grid item xs={12}>
                    <FormControl className="form-control">
                        <TextField
                            value={comentario}
                            id="txtMotivoNegado"
                            label='Comentario (Escribe un breve comentario aquí) *'
                            name="comentario"
                            minRows={3}
                            maxRows={12}
                            placeholder={'Escribe un breve comentario aquí'}
                            multiline
                            onChange={(event) => {
                                onChangeStateForInput(event);
                                setCaracteresRestantes(400 - event.target.value.length); // Actualiza el contador
                            }}
                            inputProps={{
                                maxLength: 400, // Establece el límite de caracteres
                            }}
                        />
                        <FormHelperText>{caracteresRestantes} caracteres restantes</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
        )
    }

    validar_datos = () => {
        const { validar_estado_no_null } = this
        const { actualizarMensaje, tipo } = this.props
        const { MotivoNotas, MotivosNotas, nota } = this.state
        const array_name_state = [
            'programaSelected',
            'materiaSelected',
            'MotivoNotas',
            'comentario'
        ]

        if (tipo?.codigo === 'Mat_Pro_Cor_Nota_E') {
            array_name_state.push('nombre_estudiante', 'porcentajeSelected', 'corteSelected', 'nota');
            const motivo = (MotivosNotas || []).find(item => item.id === MotivoNotas);
            if (motivo && motivo.codigo !== 'Mot_Mat_Tar') array_name_state.push('adjunto_motivo');
            if (motivo && motivo.codigo === 'Otro_Motivo_C') array_name_state.push('otro_motivo');
        }

        if (validar_estado_no_null(array_name_state)) {
            actualizarMensaje({
                titulo: "Campos sin digitar.",
                tipo: "info",
                mostrar: true,
                tiempo: 6000
            });
            return true
        }

        if (tipo?.codigo === 'Mat_Pro_Cor_Nota_E' && !/^([0-4](\.\d+)?|5(\.0+)?)$/.test(nota)) {
            actualizarMensaje({ titulo: "La nota debe estar entre 0 y 5. Ejemplo: 4.5", tipo: "info", mostrar: true, tiempo: 6000 });
            return true
        }

    }


    getStepContent(step) {
        const { Datos_Correcion } = this
        switch (step) {
            case 0:
                return <Datos_Correcion
                    setNombre_materia

                />
            default:
                return 'Unknown step';
        }
    }

    crear_solicitud = async () => {
        let { actualizarMensaje, tipo, setOpen, misDatos } = this.props

        const {
            programaSelected,
            porcentajeSelected,
            materiaSelected,
            corteSelected,
            nombre_estudiante,
            nota,
            MotivoNotas,
            adjunto_motivo,
            comentario,
            otro_motivo
        } = this.state


        let auxData = {
            tipo: tipo.id,
            tipoCode: tipo.codigo,
            programa: programaSelected.value,
            porcentaje: porcentajeSelected.value,
            corte: corteSelected.value,
            nota,
            estudiante: nombre_estudiante.value,
            misCursos: [],
            comentario,
            MotivoNotas,
            otro_motivo,
            adjunto_motivo,

            cod_materia: materiaSelected.cod_materia,
            cod_pensum: materiaSelected.cod_pensum,
            // id_grupo: nombre_materia.id_grupo,
            nombre_grupo: materiaSelected.nombre_grupo,
            nombre_materia: materiaSelected.nombre_materia,
            nom_largo: nombre_estudiante.nom_largo,
            num_identificacion_estudiante: nombre_estudiante.num_identificacion_estudiante,

            celular: misDatos.persona.celular,
            correo: misDatos.persona.correo_personal,
            telefono: misDatos.persona.telefono,
            numero_documento: misDatos.persona.identificacion,
            ciudad_expedicion: misDatos.persona.lugar_expedicion,
            tipoIdentificacion: misDatos.persona.tipo_identificacion,
            primer_nombre: misDatos.persona.primer_nombre,
            segundo_nombre: misDatos.persona.segundo_nombre,
            primer_apellido: misDatos.persona.primer_apellido,
            segundo_apellido: misDatos.persona.segundo_apellido,
        };

        const datos = await crear_form_data(auxData);

        this.setState({ cargando: true, cargando_text: 'Enviando, por favor espere' })

        formulario(`api/v1.0/matriculas/crear`, datos, 'post', async (error, estado, resp) => {

            let title = 'Ha ocurrido un error, contacte con el administrador.';
            let icon = 'error';
            if (!error) {
                if (estado === 200) {
                    icon = 'success';
                    title = resp.titulo;
                    setOpen(false);
                    this.setState({ activeStep: 0 });
                } else if (estado === 302) {
                    icon = 'info';
                    title = resp.titulo;
                } else {
                    tipo = 'info';
                    title = resp.titulo ? resp.titulo : mostrarError(resp);
                }
            }
            actualizarMensaje({ titulo: title, tipo: icon, mostrar: true, tiempo: 6000 });
            this.setState({ cargando: false })
        });
    }

    render() {
        const { open, setOpen, tipo } = this.props
        const { steps, activeStep, cargando, cargando_text } = this.state
        let lista = [
            {
                item: 'IMPORTANTE: A través de este formulario podrá ingresar su solicitud de corrección de notas, recuerde que debe diligenciar una solicitud por cada materia a la que desee se le habilite el sistema para ingreso de notas.'
            }
        ]

        if (tipo && tipo.codigo == "Mat_Pro_Cor_Nota_E") {
            // Matrícula tardía ya no pasa directo a Registro: vuelve a requerir vistos buenos (oct 2026).
            // const { MotivoNotas, MotivosNotas } = this.state
            // const motivoActual = Array.isArray(MotivosNotas) ? MotivosNotas.find(m => m.id === MotivoNotas) : null
            // if (motivoActual && motivoActual.codigo === 'Mot_Mat_Tar')
            //     lista.push({ item: 'Su solicitud pasará directamente al Departamento de Registro y Admisiones.' })
            // else
            lista.push({ item: 'Su solicitud será sujeta a aprobación por parte de Vicerrectoría Académica.' })
        }
        
        return (
            <div>

                <Dialog
                    onClose={() => setOpen(false)}
                    aria-labelledby='customized-dialog-title'
                    open={open}
                    fullWidth={true}
                    maxWidth='md'
                    className='scroll'
                >
                    <AppBarModal
                        titulo={`${tipo && tipo.nombre}`}
                        mostrarModal={() => setOpen(false)}
                        titulo_accion='Cerrar'
                        accion={() => setOpen(false)}
                    />
                    <Grid item xs={12}>
                        <AlertasSimple
                            tipo='info'
                            titulo='Estimado Docente, Datos que debe tener en cuenta:'
                            sub_titulo=''
                            lista={lista}

                        />

                    </Grid>
                    <DialogContent>
                        {cargando ? (
                            <TareasTerminadas mensaje={cargando_text} marginTop='7%' imagen={emma_w} widthImg='7%' cargando={true} />
                        ) : (
                            <div>
                                <Stepper activeStep={0} >
                                    <Step key={1} style={{ margin: 'auto' }}>
                                        <StepLabel >{'Datos Corrección'}</StepLabel>
                                    </Step>

                                </Stepper>
                                {this.getStepContent(activeStep)}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        {!cargando &&
                            (
                                <Button
                                    color='primary'
                                    onClick={this.handleNext}
                                >
                                    {activeStep === steps.length - 1 ? 'Guardar' : 'Siguiente'}
                                </Button>
                            )}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
